<template>
	<div :style="{'--dbgcolor':gcfg.BackgroundColor,'--dcolor':gcfg.TopTextColor}">
		<van-tabbar v-model="activeTabbar" @change="onTabbarChange" :style="'background-color:'+gcfg.BackgroundColor"
			active-color="#ee0a24">
			<van-tabbar-item>
				<span>首页</span>
				<template #icon="props">
					<van-icon :name="props.active ? 'wap-home':'wap-home-o'" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>搜索</span>
				<template #icon="props">
					<van-icon :name="props.active ? 'more':'more-o'" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>我的</span>
				<template #icon="props">
					<van-icon :name="props.active ? 'manager':'manager-o'" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import * as util from '@/utils/network' 
	export default {
		props: ["curactive"],
		data() {
			return {
				active: 0,
				gcfg: [],
				activeTabbar:0
			};
		},
		methods: {
			onTabbarChange(index) {
				this.setActiveTabbar()
				switch (index) {
					case 0:
						this.$router.push({
							name: 'Index'
						})
						break
					case 1:
						this.$router.push({
							name: 'PageList'
						})
						break
					case 2:
						this.$router.push({
							name: 'My'
						})
						break
					default:
				}
			},
			setActiveTabbar() {
				let that=this
				switch (that.$route.name) {
					case 'Index':
						that.activeTabbar = 0
						break
					case 'PageList':
						that.activeTabbar = 1
						break
					case 'My':
						that.activeTabbar = 2
						break
					default:
				}
			}
		},
		created: function() {
			this.setActiveTabbar()
			this.gcfg = this.$store.getters.getGcfg
		},
		watch: {
			"$store.state.gcfg": function() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style>
	.van-tabbar-item--active {
		/* 	color: var(--dcolor) !important;
		font-weight: bold; */
		/* color: #ff4539 !important;
		font-weight: 200 !important; */
		background-color: transparent;
	}

	.van-tabbar-item {
		color: #636363;
	}

	.van-popup--bottom {
		margin-bottom: 3.9em;
		width: auto;
	}

	.am-modal-hd {
		padding: 15px 10px 5px 10px;
		font-weight: 500;
	}

	.am-modal-bd {
		padding: 0 10px 15px;
		text-align: center;
	}

	.am-share-wechat-qr {
		font-size: 14px;
		color: #777;
	}

	.am-share-wx-qr img {
		width: 250px !important;
	}

	.am-share-wechat-tip {
		/* text-align: left; */
		font-size: 12px;
		line-height: 20px;
	}

	.am-share-wechat-tip em {
		color: #dd514c;
		font-weight: 700;
		font-style: normal;
		margin-left: 3px;
		margin-right: 3px;
	}
</style>
